import { lazyRouteComponent } from "@tanstack/react-router";




const Practice = lazyRouteComponent(() => import("./practice.view"), "Practice");

export const routeOptions = {
  component: Practice,
  head: () => ({
    meta: [
      { title: "Öva inför kunskapsprovet i alkohollagen – Alkoholprovet" },
      { name: "description", content: "Öva på frågor inför kunskapsprovet för serveringstillstånd. Förklaringar med lagrum, statistik per kategori och gratis dagliga frågor — inget kort krävs." },
      { property: "og:title", content: "Öva inför kunskapsprovet i alkohollagen – Alkoholprovet" },
      { property: "og:description", content: "Träna på frågor i samma format som kommunens prov för serveringstillstånd, med förklaringar och progressmätning per kategori." },
      { property: "og:url", content: "https://alkoholprovet.se/practice" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/practice" }],
  }),
};
